module.exports = __webpack_public_path__ + "img/SGSlogo.8c15db4b.png";